var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dashboard-trackplus-cards",
      on: { scroll: _vm.deactivatePopover },
    },
    [
      _vm.panel.panel_widget_id === 5
        ? _c("summary-card", {
            attrs: {
              panel: _vm.panel,
              registrationCount: _vm.registrationCount,
              devicesCount: _vm.devicesCount,
              countriesCount: _vm.countriesCount,
              isCombo: _vm.isCombo,
            },
          })
        : _vm._e(),
      _vm.panel.panel_widget_id == 6
        ? _c("expiration-card", {
            attrs: {
              panel: _vm.panel,
              expiration_details: _vm.expiration_details,
              expiryVisible: _vm.expiryVisible,
              openPopover: _vm.openPopover,
              isCombo: _vm.isCombo,
            },
            on: { viewRegistration: _vm.viewRegistration },
          })
        : _vm._e(),
      _vm.panel.panel_widget_id === 7
        ? _c("pending-card", {
            attrs: {
              panel: _vm.panel,
              pending_summary: _vm.pending_summary,
              pendingVisible: _vm.pendingVisible,
              openPopover: _vm.openPopover,
              isCombo: _vm.isCombo,
            },
            on: { viewRegistration: _vm.viewRegistration },
          })
        : _vm._e(),
      _c("permission-access-modal"),
      _vm.dashboardRecordsFlag
        ? _c("registration-details-popup", {
            attrs: {
              dashboardRecordsFlag: _vm.dashboardRecordsFlag,
              permissions: _vm.permissions,
              dataRow: _vm.activeRegistrationData,
              reportFlag: true,
            },
            on: {
              hidePopup: _vm.hidePopup,
              dashboardWidgets: _vm.dashboardWidgets,
            },
          })
        : _vm._e(),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }